/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the "Elastic License
 * 2.0", the "GNU Affero General Public License v3.0 only", and the "Server Side
 * Public License v 1"; you may not use this file except in compliance with, at
 * your election, the "Elastic License 2.0", the "GNU Affero General Public
 * License v3.0 only", or the "Server Side Public License, v 1".
 */

import * as ast from '../ast';
import * as literal from '../node_types/literal';
export const KQL_FUNCTION_NESTED = 'nested';
export function isNode(node) {
  return node.function === KQL_FUNCTION_NESTED;
}
export function buildNodeParams(path, child) {
  const pathNode = typeof path === 'string' ? ast.fromLiteralExpression(path) : literal.buildNode(path);
  return {
    arguments: [pathNode, child]
  };
}
export function toElasticsearchQuery(node, indexPattern, config = {}, context = {}) {
  var _context$nested;
  const [path, child] = node.arguments;
  const stringPath = ast.toElasticsearchQuery(path);
  const fullPath = context !== null && context !== void 0 && (_context$nested = context.nested) !== null && _context$nested !== void 0 && _context$nested.path ? `${context.nested.path}.${stringPath}` : stringPath;
  return {
    nested: {
      path: fullPath,
      query: ast.toElasticsearchQuery(child, indexPattern, config, {
        ...context,
        nested: {
          path: fullPath
        }
      }),
      score_mode: 'none',
      ...(typeof config.nestedIgnoreUnmapped === 'boolean' && {
        ignore_unmapped: config.nestedIgnoreUnmapped
      })
    }
  };
}
export function toKqlExpression(node) {
  const [path, child] = node.arguments;
  return `${literal.toKqlExpression(path)}: { ${ast.toKqlExpression(child)} }`;
}